import { uid } from "@xbs/lib-state";
export default function (store) {
    const nextState = {
        dropAreaItemsCoords: null,
        dropAreasCoords: null,
        dragItemsCoords: null,
        dragItemId: null,
        before: null,
        overAreaId: null,
        areasMeta: {},
    };
    const { before, overAreaId, dragItemId, selected, areasMeta, cardsMeta } = store.getState();
    if (overAreaId && dragItemId) {
        const area = areasMeta[overAreaId];
        const { column, columnId, rowId } = area;
        if (!column.collapsed) {
            if (selected && selected.length > 1) {
                const batchId = uid();
                selected.forEach(id => {
                    store.in.exec("move-card", {
                        id,
                        columnId,
                        rowId,
                        before,
                        $meta: {
                            batch: batchId,
                        },
                    });
                    const meta = cardsMeta[id];
                    if (meta) {
                        meta.dragging = false;
                    }
                });
            }
            else {
                store.in.exec("move-card", {
                    id: dragItemId,
                    columnId,
                    rowId,
                    before,
                });
                const meta = cardsMeta[dragItemId];
                if (meta) {
                    meta.dragging = false;
                }
            }
        }
    }
    nextState.cardsMeta = cardsMeta;
    const updatedAreasMeta = store.getState().areasMeta;
    Object.keys(updatedAreasMeta).forEach(key => {
        nextState.areasMeta[key] = {
            ...updatedAreasMeta[key],
            height: null,
        };
    });
    store.setState(nextState);
}
//# sourceMappingURL=end.js.map